import _ from 'underscore';
import { edmCampaign } from '@bingads-webui/edm-campaign';

export async function fetchCampaignData({
  pageContext,
  campaignId,
}) {
  const campaign = _.get(pageContext, ['CurrentCampaign']);
  if (!_.isEmpty(campaign)) {
    return campaign;
  }

  const {
    CurrentAccount: {
      Id: accountId,
    },
    CurrentCustomer: {
      Id: customerId,
    },
  } = pageContext;

  const res = await edmCampaign
    .Customers.$withKey(customerId)
    .Accounts.$withKey(accountId)
    .Campaigns.$withKey(campaignId)
    .get()
    .toPromise();

  return res;
}
